import type { CSSProperties, PropsWithChildren, ReactNode } from 'react';

type GlassTone = 'default' | 'light' | 'accent';

function cx(...parts: Array<string | undefined | false>): string {
  return parts.filter(Boolean).join(' ');
}

const toneClass: Record<GlassTone, string> = {
  default: 'glass',
  light: 'glass-light',
  accent: 'glass-accent',
};

export function GlassCard({
  children,
  className,
  tone = 'default',
  style,
}: PropsWithChildren<{ className?: string; tone?: GlassTone; style?: CSSProperties }>) {
  return <div className={cx(toneClass[tone], 'rounded-2xl', className)} style={style}>{children}</div>;
}

export function StatusPill({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) {
  return <span className={cx('badge-cyan text-xs px-2.5 py-1 rounded-full font-semibold', className)}>{children}</span>;
}

export function SectionTitle({
  children,
  right,
  className,
}: {
  children: ReactNode;
  right?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cx('flex items-center justify-between', className)}>
      <p className="text-[10px] font-bold uppercase tracking-widest" style={{ color: 'var(--cyan)' }}>
        {children}
      </p>
      {right}
    </div>
  );
}
